import { Navigate } from 'react-router-dom';
import { useAdmin } from '../../contexts/AdminContext';

interface RequireAdminProps {
  children: React.ReactNode;
  requireSuperAdmin?: boolean;
}

export default function RequireAdmin({ children, requireSuperAdmin = false }: RequireAdminProps) {
  const { isAdmin, isSuperAdmin, isLoading } = useAdmin();

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (requireSuperAdmin && !isSuperAdmin) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger">
          <h4>Access Denied</h4>
          <p>Super Admin access is required to view this page.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

